import { render, staticRenderFns } from "./ClientDocumentForm.vue?vue&type=template&id=b37bfd06&"
import script from "./ClientDocumentForm.vue?vue&type=script&lang=js&"
export * from "./ClientDocumentForm.vue?vue&type=script&lang=js&"
import style0 from "./ClientDocumentForm.vue?vue&type=style&index=0&id=b37bfd06&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b37bfd06')) {
      api.createRecord('b37bfd06', component.options)
    } else {
      api.reload('b37bfd06', component.options)
    }
    module.hot.accept("./ClientDocumentForm.vue?vue&type=template&id=b37bfd06&", function () {
      api.rerender('b37bfd06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientForm/components/ClientDocumentForm.vue"
export default component.exports